/* Velurya · recomendador de talla — asistente (v4: al final muestra la guía de tallas completa de Kiwi con la talla recomendada marcada).
   Necesita velurya-talla-datos.js (VF). Las figuras son assets del tema (vf-*.webp) que el snippet pasa en data-img.
   La guía final se lee de la tabla que Kiwi Size Chart pinta en la ficha (table.ks-table); si no está, usa las tablas de VF. */
(function(){
  if (window.__vfit || !window.VF) return; window.__vfit = 1;
  var root = document.querySelector('.vfit[data-key]'); if (!root) return;
  var KEY = root.dataset.key, CH = VF.CH[KEY], SEX = CH.sex, AV = [], IMG = {};
  try { AV = JSON.parse(root.dataset.sizes); } catch(e) {}
  try { IMG = JSON.parse(root.dataset.img); } catch(e) {}
  var LS = 'vfit_' + SEX, prof = null;
  try { prof = JSON.parse(localStorage.getItem(LS) || 'null'); } catch(e) {}

  // ---------- pasos: solo lo que mide la tabla de esta prenda (+ abdomen, que afecta a todo) ----------
  var has = {}; CH.m.forEach(function(m){ has[m.k] = 1; });
  // Pantalones y Conjuntos: se pregunta por pecho, abdomen y caderas, y al final salen las dos tablas (arriba y abajo)
  var PYC = KEY === 'pyc-sup' || KEY === 'pyc-inf';
  if (PYC) { has.bust = 1; has.waist = 1; has.hip = 1; }
  var LBL = SEX === 'f'
    ? { bust: ['Forma de tu pecho', ['Pequeño','Medio','Amplio']], waist: ['Forma de tu abdomen', ['Plano','Medio','Abultado']], hip: ['Forma de tus caderas', ['Rectas','Medias','Anchas']] }
    : { bust: ['Forma de tu pecho', ['Estrecho','Medio','Ancho']], waist: ['Forma de tu abdomen', ['Plano','Medio','Abultado']] };
  var ST = [];
  if (has.bust) ST.push('bust');
  ST.push('waist');
  if (has.hip && SEX === 'f') ST.push('hip');

  // Talla de sujetador → contorno de pecho (cm). Diferencia pecho-bajopecho por copa (UE): AA≈11, A≈13… K≈33
  var BANDS = [75,80,85,90,95,100,105,110,115,120,125,130,135,140];
  var CUPS = ['AA','A','B','C','D','E','F','G','H','I','J','K'];
  function braBust(b){ return b && b.band && b.cup != null ? b.band + 11 + 2 * b.cup : null; }

  var S = { h: '', w: '', s: { bust: 1, waist: 1, hip: 1 }, fit: 1, own: null, bra: null, braOpen: false, step: 0 };
  if (prof) { S.h = prof.h || ''; S.w = prof.w || ''; if (prof.s) S.s = prof.s; if (prof.fit != null) S.fit = prof.fit; if (prof.own) S.own = prof.own; if (prof.bra) S.bra = prof.bra; }
  var dlg, bodyEl, titleEl, backBtn, last = null, pre = false;

  function img(k, i){ return IMG[SEX + '-' + k + '-' + i] || ''; }
  function preload(){
    if (pre) return; pre = true;
    ST.forEach(function(k){ for (var i = 0; i < 3; i++) { var u = img(k, i); if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; } } });
  }
  function el(t, c, h){ var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function open(){
    if (!dlg) build();
    S.step = 0; render(); preload();
    dlg.hidden = false; document.documentElement.classList.add('vfit-lock');
    requestAnimationFrame(function(){ dlg.classList.add('is-open'); });
    var f = dlg.querySelector('input'); if (f) setTimeout(function(){ f.focus(); }, 250);
  }
  function close(){
    dlg.classList.remove('is-open'); document.documentElement.classList.remove('vfit-lock');
    setTimeout(function(){ dlg.hidden = true; }, 220);
  }
  function build(){
    css();
    dlg = el('div', 'vfit-m'); dlg.hidden = true; dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true'); dlg.setAttribute('aria-labelledby', 'vfit-t');
    dlg.innerHTML = '<span class="vfit-m__bg"></span><div class="vfit-m__p"><div class="vfit-m__h"><button type="button" class="vfit-m__b" aria-label="Atrás">‹</button><p class="vfit-m__t" id="vfit-t">Encuentra tu talla</p><button type="button" class="vfit-m__x" aria-label="Cerrar">×</button></div><div class="vfit-m__c"></div></div>';
    document.body.appendChild(dlg);
    bodyEl = dlg.querySelector('.vfit-m__c'); titleEl = dlg.querySelector('.vfit-m__t'); backBtn = dlg.querySelector('.vfit-m__b');
    dlg.querySelector('.vfit-m__bg').onclick = close; dlg.querySelector('.vfit-m__x').onclick = close;
    backBtn.onclick = function(){ if (S.step === 'own') S.step = 0; else if (S.step === 'res') S.step = S.own ? 'own' : ST.length + 1; else S.step = Math.max(0, S.step - 1); render(); };
    dlg.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  }
  function dots(i, n){ var h = '<div class="vfit-m__d">'; for (var j = 0; j < n; j++) h += '<span' + (j <= i ? ' class="on"' : '') + '></span>'; return h + '</div>'; }
  function braBlock(){
    var b = S.bra || {}, h = '<button type="button" class="vfit-m__lk vfit-m__lk--bra" data-a="bra" aria-expanded="' + S.braOpen + '">' + (S.braOpen ? 'Ocultar talla de sujetador' : '¿Sabes tu talla de sujetador? Indícala para más precisión') + '</button>';
    if (!S.braOpen) return h;
    h += '<div class="vfit-bra"><div><p>Talla</p><div class="vfit-bra__g">' + BANDS.map(function(v){
      return '<button type="button" class="vfit-bra__o' + (b.band === v ? ' on' : '') + '" data-band="' + v + '" aria-pressed="' + (b.band === v) + '">' + v + '</button>';
    }).join('') + '</div></div><div><p>Copa</p><div class="vfit-bra__g">' + CUPS.map(function(v, i){
      return '<button type="button" class="vfit-bra__o' + (b.cup === i ? ' on' : '') + '" data-cup="' + i + '" aria-pressed="' + (b.cup === i) + '">' + v + '</button>';
    }).join('') + '</div></div>' + (S.bra ? '<button type="button" class="vfit-m__lk" data-a="bra-clear">Borrar talla de sujetador</button>' : '') + '</div>';
    return h;
  }
  function render(){
    var n = ST.length + 2, st = S.step, h = '';
    backBtn.style.visibility = st === 0 ? 'hidden' : 'visible';
    if (st === 0) {
      titleEl.textContent = 'Encuentra tu talla';
      h = dots(0, n) + '<p class="vfit-m__l">Tu altura y tu peso</p>' +
        '<div class="vfit-m__in"><label>Altura<span><input type="number" inputmode="numeric" min="140" max="210" data-f="h" value="' + S.h + '" placeholder="' + (SEX === 'f' ? 165 : 178) + '"><em>cm</em></span></label>' +
        '<label>Peso<span><input type="number" inputmode="numeric" min="35" max="160" data-f="w" value="' + S.w + '" placeholder="' + (SEX === 'f' ? 60 : 78) + '"><em>kg</em></span></label></div>' +
        '<p class="vfit-m__e" hidden>Revisa los datos: altura entre 140 y 210 cm, peso entre 35 y 160 kg.</p>' +
        '<button type="button" class="vfit-m__go" data-a="next">Siguiente</button>' +
        '<button type="button" class="vfit-m__lk" data-a="own">Prefiero poner mis medidas exactas</button>' +
        '<p class="vfit-m__pv">Tus datos solo se guardan en este dispositivo para recordarte tu talla.</p>';
    } else if (st === 'own') {
      titleEl.textContent = 'Tus medidas';
      var o = S.own || {};
      h = '<p class="vfit-m__l">Mide tu cuerpo con una cinta métrica</p><div class="vfit-m__in vfit-m__in--3">' +
        inp('bust', 'Pecho', o.bust) + inp('waist', 'Cintura', o.waist) + inp('hip', 'Cadera', o.hip) + '</div>' +
        '<p class="vfit-m__hint">Pecho: por la parte más ancha. Cintura: por la parte más estrecha. Cadera: por la parte más ancha.</p>' +
        '<p class="vfit-m__e" hidden>Revisa las medidas (entre 50 y 180 cm).</p>' +
        fitRow() + '<button type="button" class="vfit-m__go" data-a="own-ok">Ver mi talla</button>';
    } else if (st <= ST.length) {
      var k = ST[st - 1], L = LBL[k];
      titleEl.textContent = 'Tu silueta';
      h = dots(st, n) + '<p class="vfit-m__q">' + L[0] + '</p><p class="vfit-m__sub">Posibles formas para tu altura y peso:</p>' +
        '<div class="vfit-fig" role="radiogroup" aria-label="' + L[0] + '">' + L[1].map(function(x, i){
          var on = S.s[k] === i;
          return '<button type="button" role="radio" class="vfit-fig__o' + (on ? ' on' : '') + '" aria-checked="' + on + '" data-k="' + k + '" data-i="' + i + '">' +
            '<img src="' + img(k, i) + '" alt="" width="300" height="300" decoding="async"><span>' + x + '</span></button>';
        }).join('') + '</div>' + (k === 'bust' && SEX === 'f' ? braBlock() : '') +
        '<button type="button" class="vfit-m__go" data-a="next">Siguiente</button>';
    } else if (st === ST.length + 1) {
      titleEl.textContent = '¿Cómo te gusta que quede?';
      h = dots(st, n) + fitRow(true) + '<button type="button" class="vfit-m__go" data-a="calc">Ver mi talla</button>';
    } else {
      titleEl.textContent = 'Tu talla';
      h = result();
    }
    bodyEl.innerHTML = h;
  }
  function inp(k, l, v){ return '<label>' + l + '<span><input type="number" inputmode="decimal" min="50" max="180" data-o="' + k + '" value="' + (v || '') + '"><em>cm</em></span></label>'; }
  function fitRow(big){
    var o = [['Ajustado','Ceñido al cuerpo'],['Normal','Como tu talla de siempre'],['Holgado','Con más espacio']];
    return (big ? '' : '<p class="vfit-m__l">¿Cómo te gusta que quede?</p>') + '<div class="vfit-m__fit" role="radiogroup">' + o.map(function(x, i){
      return '<button type="button" role="radio" class="vfit__fit' + (S.fit === i ? ' on' : '') + '" aria-checked="' + (S.fit === i) + '" data-fit="' + i + '"><strong>' + x[0] + '</strong><span>' + x[1] + '</span></button>';
    }).join('') + '</div>';
  }
  function measures(){
    if (S.own) return S.own;
    var m = VF.estimate(SEX, +S.h, +S.w, S.s), bb = SEX === 'f' ? braBust(S.bra) : null;
    if (bb) m.bust = bb;
    return m;
  }

  // ---------- guía de tallas completa (de Kiwi) con la talla recomendada marcada ----------
  var TOP = /pecho|busto|hombro|manga/i, BOTTOM = /cintura|cadera|tiro|pierna/i;
  function kiwiTables(){
    var out = [], seen = {};
    document.querySelectorAll('table.ks-table').forEach(function(t){
      var rows = [].slice.call(t.rows).map(function(r){
        return [].slice.call(r.cells).map(function(c){ return c.textContent.replace(/\s+/g, ' ').trim(); });
      }).filter(function(r){ return r.some(function(c){ return c !== ''; }); });
      if (rows.length < 2 || rows[0].length < 2) return;
      var sig = JSON.stringify(rows); if (seen[sig]) return; seen[sig] = 1;
      var head = rows[0].join(' ');
      out.push({ rows: rows, head: head, kind: TOP.test(head) ? 'top' : BOTTOM.test(head) ? 'bottom' : '' });
    });
    // Parte de arriba primero, luego la de abajo
    out.sort(function(a, b){ return (a.kind === 'top' ? 0 : 1) - (b.kind === 'top' ? 0 : 1); });
    return out;
  }
  function vfTable(c, kind){
    var rows = [['Talla'].concat(c.m.map(function(m){ return m.l + ' (cm)'; }))];
    c.sizes.forEach(function(s, i){
      rows.push([s].concat(c.m.map(function(m){ var v = m.v[i]; return v && v.join ? v[0] + '-' + v[1] : String(v); })));
    });
    return { rows: rows, kind: kind || '' };
  }
  function vfTables(){
    if (PYC) return [vfTable(VF.CH['pyc-sup'], 'top'), vfTable(VF.CH['pyc-inf'], 'bottom')];
    return [vfTable(CH)];
  }
  // En Pantalones y Conjuntos: talla recomendada para la parte de arriba (pecho) y para la de abajo (cintura y cadera)
  function parts(){
    if (!PYC) return null;
    var m = measures(), a = VF.recommend('pyc-sup', m, S.fit, AV), b = VF.recommend('pyc-inf', m, S.fit, AV);
    return { top: a && a.size, bottom: b && b.size };
  }
  function guide(size){
    var ts = kiwiTables(); if (!ts.length) ts = vfTables();
    var pt = size ? parts() : null, hit = false, NAME = { top: 'Parte de arriba', bottom: 'Parte de abajo' };
    var h = ts.map(function(t){
      var hd = t.rows[0], body = t.rows.slice(1);
      var sz = pt && pt[t.kind] ? pt[t.kind] : size, want = sz ? VF.norm(sz) : '';
      var ttl = PYC && NAME[t.kind] ? '<p class="vfit-g__h">' + NAME[t.kind] + (sz ? ' · tu talla <b>' + esc(sz) + '</b>' : '') + '</p>' : '';
      return ttl + '<div class="vfit-g__w"><table class="vfit-g__t"><thead><tr>' + hd.map(function(c, i){
        return '<th scope="col">' + esc(c || (i === 0 ? 'Talla' : '')) + '</th>';
      }).join('') + '</tr></thead><tbody>' + body.map(function(r){
        var on = want && VF.norm(r[0]) === want; if (on) hit = true;
        return '<tr' + (on ? ' class="on"' : '') + '><th scope="row">' + esc(r[0]) + (on ? '<span>Recomendada</span>' : '') + '</th>' +
          r.slice(1).map(function(c){ return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>';
      }).join('') + '</tbody></table></div>';
    }).join('');
    return '<div class="vfit-g"><p class="vfit-m__l">Guía de tallas de esta prenda</p>' + h +
      '<p class="vfit-m__hint">Medidas en centímetros.' + (hit ? ' Tu talla recomendada aparece marcada.' : '') + '</p></div>';
  }
  function css(){
    if (document.getElementById('vfit-g-css')) return;
    var s = document.createElement('style'); s.id = 'vfit-g-css';
    s.textContent = '.vfit-g{margin-top:1.8rem}' +
      '.vfit-g__h{margin:1.2rem 0 .6rem;font-size:1.35rem;font-weight:600;color:#1c1a18}' +
      '.vfit-g__h b{display:inline-block;min-width:2.4rem;margin-left:.2rem;padding:.1rem .6rem;border-radius:.4rem;background:#1c1a18;color:#fff;text-align:center}' +
      '.vfit-m__set{margin:1.2rem 0 0;font-size:1.35rem;text-align:center}' +
      '.vfit-g__w{overflow-x:auto;-webkit-overflow-scrolling:touch;margin:0 0 1rem;border:1px solid #eee6da;border-radius:.6rem}' +
      '.vfit-g__t{width:100%;border-collapse:collapse;font-size:1.3rem;text-align:center;color:#1c1a18}' +
      '.vfit-g__t th,.vfit-g__t td{padding:.85rem .7rem;border:0;border-bottom:1px solid #eee6da;white-space:nowrap}' +
      '.vfit-g__t thead th{background:#faf7f2;font-size:1.05rem;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:rgba(28,26,24,.7);white-space:normal;line-height:1.25;vertical-align:bottom}' +
      '.vfit-g__t tbody th{text-align:left;padding-left:1rem;font-weight:700}' +
      '.vfit-g__t tbody tr:last-child th,.vfit-g__t tbody tr:last-child td{border-bottom:0}' +
      '.vfit-g__t tr.on th,.vfit-g__t tr.on td{background:#1c1a18;color:#fff}' +
      '.vfit-g__t tr.on th span{display:block;margin-top:.15rem;font-size:.9rem;font-weight:400;letter-spacing:.08em;text-transform:uppercase;opacity:.8}';
    document.head.appendChild(s);
  }

  function result(){
    var r = VF.recommend(KEY, measures(), S.fit, AV); last = r;
    if (!r || !r.size) return '<p class="vfit-m__l">No hemos podido calcular tu talla para esta prenda. Escríbenos y te ayudamos.</p>' + guide(null);
    var fitTxt = ['más ajustada', 'más holgada'];
    var alt = r.alt ? '<p class="vfit-m__alt">Si la prefieres ' + (r.altWhy === 'up' ? fitTxt[1] : fitTxt[0]) + ', elige la <strong>' + r.alt + '</strong>.</p>' : '';
    var warn = r.note === 'big' ? '<p class="vfit-m__w">Es la talla más grande de esta prenda y puede quedarte justa.</p>'
             : r.note === 'small' ? '<p class="vfit-m__w">Es la talla más pequeña de esta prenda y puede quedarte algo amplia.</p>'
             : !r.exact ? '<p class="vfit-m__w">Tu talla ideal no está disponible en esta prenda; esta es la más cercana.</p>' : '';
    var pt = parts(), set = '';
    if (pt && pt.top && pt.bottom) set = pt.top === pt.bottom
      ? '<p class="vfit-m__set">Para el conjunto completo: <strong>' + pt.top + '</strong> arriba y abajo.</p>'
      : '<p class="vfit-m__set">Para el conjunto completo: <strong>' + pt.top + '</strong> en la parte de arriba y <strong>' + pt.bottom + '</strong> en la de abajo.</p>';
    return '<div class="vfit-m__res"><span>Tu talla recomendada</span><b>' + r.size + '</b></div>' + alt + warn + set +
      guide(r.size) +
      '<button type="button" class="vfit-m__go" data-a="apply">Elegir talla ' + r.size + '</button>' +
      '<button type="button" class="vfit-m__lk" data-a="again">Volver a calcular</button>';
  }
  function save(){ try { localStorage.setItem(LS, JSON.stringify({ h: S.h, w: S.w, s: S.s, fit: S.fit, own: S.own, bra: S.bra })); } catch(e) {} }

  // ---------- elegir la talla en la ficha ----------
  var COLOR = /colou?r|couleur|esencial|limitado|versi/i;
  function pickSize(sz){
    var want = VF.norm(sz), done = false;
    document.querySelectorAll('.globo-swatch-product-detail .swatch--gl').forEach(function(g){
      if (done) return; var lg = g.querySelector('legend[data-name]');
      if (!lg || COLOR.test(lg.getAttribute('data-name'))) return;
      g.querySelectorAll('li[data-value]').forEach(function(li){
        if (done || VF.norm(li.getAttribute('data-value')) !== want) return;
        var i = li.querySelector('input'); if (i && !i.checked) { (li.querySelector('label') || i).click(); } done = true;
      });
    });
    if (done) return true;
    document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input').forEach(function(fs){
      if (done) return; var x = fs.querySelector('[data-option-name],legend,label'); var nm = x ? (x.getAttribute('data-option-name') || x.textContent) : '';
      if (COLOR.test(nm)) return;
      fs.querySelectorAll('input[type=radio]').forEach(function(i){ if (!done && VF.norm(i.value) === want) { i.click(); done = true; } });
      var sel = fs.querySelector('select');
      if (!done && sel) for (var k = 0; k < sel.options.length; k++) if (VF.norm(sel.options[k].value) === want) { sel.value = sel.options[k].value; sel.dispatchEvent(new Event('change', { bubbles: true })); done = true; break; }
    });
    return done;
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest('.vfit__open'); if (t) { e.preventDefault(); open(); return; }
    if (!dlg || !dlg.contains(e.target)) return;
    var b = e.target.closest('button'); if (!b) return;
    if (b.dataset.k) {
      S.s[b.dataset.k] = +b.dataset.i;
      dlg.querySelectorAll('.vfit-fig__o').forEach(function(x){ var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); });
      return;
    }
    if (b.dataset.band) { S.bra = S.bra || {}; S.bra.band = +b.dataset.band; render(); return; }
    if (b.dataset.cup != null) { S.bra = S.bra || {}; S.bra.cup = +b.dataset.cup; render(); return; }
    if (b.dataset.fit != null) { S.fit = +b.dataset.fit; dlg.querySelectorAll('.vfit__fit').forEach(function(x){ var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); }); return; }
    var a = b.dataset.a; if (!a) return;
    if (a === 'bra') { S.braOpen = !S.braOpen; render(); return; }
    if (a === 'bra-clear') { S.bra = null; render(); return; }
    if (a === 'own') { S.step = 'own'; render(); return; }
    if (a === 'next' && S.step === 0) {
      var h = +dlg.querySelector('[data-f=h]').value, w = +dlg.querySelector('[data-f=w]').value;
      if (!(h >= 140 && h <= 210 && w >= 35 && w <= 160)) { dlg.querySelector('.vfit-m__e').hidden = false; return; }
      S.h = h; S.w = w; S.own = null; S.step = 1; render(); return;
    }
    if (a === 'next') { if (S.bra && !braBust(S.bra)) S.bra = null; S.step++; render(); return; }
    if (a === 'own-ok') {
      var o = {}, ok = true;
      dlg.querySelectorAll('[data-o]').forEach(function(i){ var v = parseFloat(String(i.value).replace(',', '.')); if (!(v >= 50 && v <= 180)) ok = false; o[i.dataset.o] = v; });
      if (!ok) { dlg.querySelector('.vfit-m__e').hidden = false; return; }
      S.own = o; S.step = 'res'; save(); render(); paint(); return;
    }
    if (a === 'calc') { S.step = 'res'; save(); render(); paint(); return; }
    if (a === 'again') { S.step = 0; render(); return; }
    if (a === 'apply' && last) { pickSize(last.size); close(); paint(); }
  });

  // Botón: si ya calculó su talla en otra prenda, se la enseñamos directamente
  function paint(){
    var has = S.own || (S.h && S.w); if (!has) return;
    var r = VF.recommend(KEY, measures(), S.fit, AV); if (!r || !r.size) return;
    document.querySelectorAll('.vfit__sub').forEach(function(s){ s.innerHTML = 'Tu talla: <strong>' + r.size + '</strong>'; });
  }
  if (prof) paint();
})();
